import { Col, Row } from "reactstrap";
import CenterCenterVerticalContainer from "../../components/layout/CenterCenterVerticalContainer";
import MainPageComponent from "../../components/page/MainPageComponent";

function UserProfileView() {
    let breadcrumbPath = [
        { value: 'Inicio', href: '/' },
        { value: 'Usuario', href: '/user' },
        { value: 'Perfil', href: '' }
    ];

	return (
        <MainPageComponent requireAuthentication={true} path={breadcrumbPath }>
            <CenterCenterVerticalContainer>
               
                <Row>
                    <Col>
                        <h1>Perfil de usuario</h1>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        Here goes the content for this page
                    </Col>
                </Row>
            </CenterCenterVerticalContainer>
        </MainPageComponent>
	);
}

export default UserProfileView;